<template>
  <footer>
    <div class="row">
      <app-menu-social-links />
      <app-menu-internationalization
        v-if="!error"
        :total-counts="totalCounts"
      />
    </div>

    <footer-links-desktop />

    <payment-types />

    <div class="footnotes">
      <version />
      <copyright />
    </div>
    <img
      loading="lazy"
      src="@/assets/homepage/footer-background-800.jpg"
      srcset="
        ~/assets/homepage/footer-background-800.jpg   800w,
        ~/assets/homepage/footer-background-1200.jpg 1200w,
        ~/assets/homepage/footer-background-1600.jpg 1600w,
        ~/assets/homepage/footer-background-2000.jpg 2000w
      "
      sizes="100vw"
      width="768"
      height="486"
      alt=""
    />
  </footer>
</template>

<script setup lang="ts">
const error = useError()
defineProps<{
  totalCounts?: number
}>()
</script>

<style scoped>
footer {
  background: #62bdff;
  margin: 6em 0 0 0;
  min-height: 60em;
  padding: 3em 0 15em;
  position: relative;
  width: 100%;
  overflow: hidden;
}

img {
  bottom: 0;
  height: auto;
  left: 0;
  object-fit: scale-down;
  position: absolute;
  right: 0;
  top: auto;
  width: 100%;
  z-index: 0;
}

.row {
  flex-wrap: wrap-reverse;
  gap: 3em;
  justify-content: space-between;
  padding: 0 5em;
  position: relative;
  z-index: 2;
}

.footnotes {
  align-items: center;
  bottom: 0;
  display: flex;
  flex-direction: row;
  gap: 1em;
  justify-content: space-between;
  left: 0;
  padding: 2em 5em;
  position: absolute;
  right: 0;
  top: auto;
  z-index: 1;
}

.footnotes :deep(p) {
  color: white;
  margin: 0;
  padding: 0;
  text-shadow: 1px 1px 2px #000000;
}

footer :deep(.payment-types) {
  position: relative;
  z-index: 1;
  padding: 0.5em 5em;
  justify-content: start;
}

footer :deep(.payment-types img) {
  height: 2.5em;
  margin: 0 0.75em;
}

footer :deep(.payment-types img:first-of-type) {
  margin-left: 0;
}

footer :deep(.payment-types img:last-of-type) {
  margin-right: 0;
}

@media (min-width: 1606px) {
  footer {
    padding-bottom: 30em;
  }
}

@media (min-width: 2000px) {
  footer img {
    object-fit: cover;
  }
}
</style>
